class LeafletCustom {
    constructor() {
        // add global class identifier
        this.class = {
            rlpmaps: '.js-rlpmaps-map',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    // eslint-disable-next-line class-methods-use-this
    rlpMaps(url, layers, format, attribution, uid, mapObject, settingsMap1) {
        const settingsMap = settingsMap1;
        settingsMap.run = () => {
            settingsMap.zoom = mapObject.dataset.zoom;

            if (Number.isNaN(parseInt(settingsMap.zoom, 10))) {
                settingsMap.zoom = 7;
            }

            settingsMap.autoFit = mapObject.dataset.autofit;
            settingsMap.focusFirst = mapObject.dataset.focusFirst;

            const records = document.getElementById(`rlpmaps__records__${uid}`);

            if (parseInt(settingsMap.focusFirst, 10) === 1) {
                settingsMap.center = [
                    parseFloat(records.childNodes[0].getAttribute('data-lat')),
                    parseFloat(records.childNodes[0].getAttribute('data-lng')),
                ];
            }

            settingsMap.map = L.map(mapObject.getAttribute('id')).setView(settingsMap.center, settingsMap.zoom);
            L.tileLayer
                .wms(url, {
                    layers,
                    format,
                    transparent: true,
                    attribution,
                })
                .addTo(settingsMap.map);

            const rlpIcon = L.icon({
                iconUrl: '/typo3conf/ext/rlp_maps/Resources/Public/Images/RLP_marker_Icon.png',
                iconRetinaUrl: '/typo3conf/ext/rlp_maps/Resources/Public/Images/RLP_marker_Icon_2x.png',
                shadowUrl: '/typo3conf/ext/rlp_maps/Resources/Public/Css/images/marker-shadow.png',
                iconSize: [25, 41],
                iconAnchor: [12, 41],
                popupAnchor: [1, -34],
                tooltipAnchor: [16, -28],
                shadowSize: [41, 41],
            });
            for (let i = 0; i < records.childNodes.length; i += 1) {
                const item = records.childNodes[i];
                const dataId = item.getAttribute('data-id');

                const marker = L.marker([item.getAttribute('data-lat'), item.getAttribute('data-lng')], { icon: rlpIcon })
                    .addTo(settingsMap.map)
                    .bindPopup(document.getElementById(`rlpmaps__record-${dataId}`).innerHTML);
                settingsMap.markers.push(marker);
            }
            const group = new L.featureGroup(settingsMap.markers); // eslint-disable-line  new-cap
            if (parseInt(settingsMap.autoFit, 10) === 1) {
                settingsMap.map.fitBounds(group.getBounds());
            }
        };

        settingsMap.openMarker = (markerId) => {
            settingsMap.markers[markerId].openPopup();
        };

        return settingsMap;
    }

    /**
     * initialize functions
     */
    init() {
        document.querySelectorAll(this.class.rlpmaps).forEach((map) => {
            let url = '';
            let attribution = '';
            const dataMapId = map.dataset.mapId;
            let layers = '';
            let format = '';
            const serviceUrl = 'https://maps.rlp.de/services/services-rlp.json';
            const dataUid = map.dataset.uid;
            // const map = this;
            const settingsMap = {
                map: null,
                markers: [],
                center: [49.957, 7.152],
                zoom: null,
                focusFirst: 0,
                autoFit: 0,
            };
            const self = this;
            const xhr = new XMLHttpRequest();
            xhr.open('POST', serviceUrl);
            xhr.addEventListener('load', () => {
                if (xhr.status === 200) {
                    const data = JSON.parse(xhr.responseText);
                    if (data.error) {
                        // console.log(data.error);
                    } else {
                        for (let i = 0; i < data.length; i += 1) {
                            if (data[i].id === dataMapId) {
                                attribution = data[i].layerAttribution;
                                url = data[i].url;
                                layers = data[i].layers;
                                format = data[i].format;
                            }
                        }

                        // eslint-disable-next-line max-len
                        const rlpMapsMapInstance = self.rlpMaps(url, layers, format, attribution, dataUid, map, settingsMap);
                        rlpMapsMapInstance.run();
                        document.addEventListener('click', (event) => {
                            if (!event.target.matches('.rlpmaps__markerlink')) {
                                return;
                            }
                            event.preventDefault();
                            const element = event.target;
                            rlpMapsMapInstance.openMarker(parseInt(element.getAttribute('data-iteration-id'), 10));
                        }, false);
                    }
                } else {
                    // console.log('Request failed.  Returned status of ' + xhr.status);
                }
            });
            xhr.send();
        });
    }
}

export default new LeafletCustom();
